module.exports = __webpack_public_path__ + "static/media/sologon.a2a8d0e7.jpg";